import React from "react";
import { useApp } from "@/context/AppContext";

// Small reusable mailto: link to the support address. Consistent visual
// treatment across the disclaimer, FAQ footer and Dashboard footer.
//
// Props:
//   variant="inline" (default) — used inline right after the disclaimer.
//                                Compact "Segnala qui" CTA next to the text.
//   variant="full"             — full "Scrivici a <email>" clickable link.
//   testid                     — required for tests.
//   subject                    — optional mailto subject.
export default function SupportMailLink({ variant = "inline", testid, subject }) {
  const { t } = useApp();
  const email = t.common.supportEmail;
  const href = `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;

  if (variant === "full") {
    return (
      <a
        href={href}
        data-testid={testid}
        className="text-terracotta hover:text-terracotta-hover font-sans font-semibold underline decoration-terracotta/30 underline-offset-2 hover:decoration-terracotta transition-colors"
      >
        {t.common.supportWriteUs} {email}
      </a>
    );
  }
  // inline (compact)
  return (
    <a
      href={href}
      data-testid={testid}
      className="text-terracotta hover:text-terracotta-hover font-sans font-semibold underline decoration-terracotta/30 underline-offset-2 hover:decoration-terracotta transition-colors"
    >
      {t.common.supportInlineCta}
    </a>
  );
}
